import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/contact-form-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/footer-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/header-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitch"] */ "/app/src/components/ui/locale-switch.tsx");
